export const USER_GROUPS_TBL_HEADERS =[
  {
    label: 'User Group Code',
    field: 'user_group_code',
    sort: 'asc'
  },
  {
    label: 'User Group Name',
    field: 'user_group_name',
    sort: 'asc'
  },
  {
    label: 'Create By',
    field: 'create_by',
    sort: 'asc'
  },
  {
    label: 'Create DateTime',
    field: 'create_datetime',
    sort: 'asc'
  },
  {
    label: 'Last Modify By',
    field: 'last_modify_by',
    sort: 'asc'
  },
  {
    label: 'Modified DateTime',
    field: 'modified_datetime',
    sort: 'asc'
  },
  {
    label: 'Active',
    field: 'active',
    sort: 'asc'
  },
  {
    label: 'Edit',
    field: 'edit',
    sort: 'asc'
  },
  {
    label: 'Users',
    field: 'users',
    sort: 'asc'
  },
];

export const USERS_TBL_HEADERS =[
  {
    label: 'User Id',
    field: 'user_id',
    sort: 'asc'
  },
  {
    label: 'Employee Id',
    field: 'employee_id',
    sort: 'asc'
  },
  {
    label: 'First Name',
    field: 'first_name',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'last_name',
    sort: 'asc'
  },
  {
    label: 'NIC',
    field: 'nic',
    sort: 'asc'
  },
  {
    label: 'Mobile',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Active',
    field: 'active',
    sort: 'asc'
  },
  {
    label: 'Remove',
    field: 'remove',
    sort: 'asc'
  },
];

export const ADD_USERS_TBL_HEADERS =[
  {
    label: 'User Id',
    field: 'user_id',
    sort: 'asc'
  },
  {
    label: 'Employee Id',
    field: 'employee_id',
    sort: 'asc'
  },
  {
    label: 'First Name',
    field: 'first_name',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'last_name',
    sort: 'asc'
  },
  {
    label: 'NIC',
    field: 'nic',
    sort: 'asc'
  },
  {
    label: 'Mobile',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Active',
    field: 'active',
    sort: 'asc'
  },
  {
    label: 'Add To List',
    field: 'add',
    sort: 'asc'
  },
];
